import React from 'react';
import "../../styles/Differentiators.css";

export default function Differentiators() {
  const perks = [
    { glyph: "👨‍🏫", title: "Expert-Led Learning", desc: "Learn from top creators and industry experts with real-world experience." },
    { glyph: "🛠️", title: "Practical Approach", desc: "Hands-on projects and assignments to help you learn by doing." },
    { glyph: "🤝", title: "Community First", desc: "Join a supportive community of creators, collaborate and grow together." },
    { glyph: "🎯", title: "Career Focused", desc: "Guidance on building personal brand and monetizing your skills." },
    { glyph: "🛠️", title: "Lifetime Support", desc: "We're with you at every step of your creator journey and beyond." }
  ];

  return (
    <section className="about-client-diff-dark-block">
      <div className="about-client-max-width diff-ribbon-container">
        
        
        <div className="diff-ribbon-header">
          <span className="title-yellow-tint">WHAT MAKES US DIFFERENT</span>
        </div>

        
        <div className="diff-perks-five-column-track">
          {perks.map((perk, idx) => (
            <React.Fragment key={idx}>
              
              
              <div className="differentiator-card-custom">
                <div className="icon-circle-shell">
                  <span>{perk.glyph}</span>
                </div>
                <div className="card-text-block">
                  <h4>{perk.title}</h4>
                  <p>{perk.desc}</p>
                </div>
              </div>

              
              {idx < perks.length - 1 && <div className="diff-vertical-divider" />}
              
            </React.Fragment>
          ))}
        </div>

      </div>
    </section>
  );
}